const {KitModule, registerModule} = window;

// no space as it will be triggered from click
const OPEN_SUBNAV_KEYS = ['Enter', 'ArrowDown'];

class Nav extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
  }

  setVars() {
    this.$nav = document.querySelector('.nav');
    this.$menuCheckbox = document.querySelector('.nav-menu-checkbox');
    this.$desktopSubnavButtons = document.querySelectorAll('.desktop-subnav__button');
    this.searchIsOpen = false;
  }

  bindEvents() {
    // events
    this.$element.addEventListener('keydown', this);
    this.$element.addEventListener('click', this);
    this.$menu.addEventListener('mouseover', this);
    this.$menuCheckbox.addEventListener('change', this);
    this.$menuLabel.addEventListener('click', this.onMenuLabelClick.bind(this));
    // browser hack - fire click on touchstart, avoid :hover & focus
    this.$menuLabel.addEventListener('touchstart', function() {});

    window.addEventListener('searchopen', this);
    window.addEventListener('searchclose', this);

    this.bindMediaQuery();

    window.addEventListener('resize', this);
  }

  onresize() {
    if (this.isDesktop) {
      this.$menuCheckbox.checked = false;
      this.$nav.style.position = 'sticky';
      this.isMenuOpen = this.$menuCheckbox.checked;
      document.documentElement.classList.remove('nav-menu-open', this.isMenuOpen);
    }
  }

  bindMediaQuery() {
    // get media query from custom property
    const rootStyle = getComputedStyle(document.documentElement);

    // max nav - mobile
    const navQuery = rootStyle.getPropertyValue('--max-nav-media-query');
    this.navMediaQuery = window.matchMedia(navQuery);
    // listen and set initial
    this.navMediaQuery.addEventListener('change', this.onNavMediaChange.bind(this));
    this.onNavMediaChange(this.navMediaQuery);
  }

  onNavMediaChange(mobileMediaQuery) {
    this.isMobile = mobileMediaQuery.matches;
    this.isDesktop = !this.isMobile;
  }

  onsearchopen() {
    this.searchIsOpen = true;
    if (this.isMenuOpen) this.$menuCheckbox.click();
  }

  onsearchclose() {
    this.searchIsOpen = false;
    if (this.isMobile) {
      this.closeSubnav();
      if (this.isMenuOpen) this.$menuCheckbox.click();
    }
  }

  // toggle subnav on .nav__item__button click
  onclick(event) {
    const $itemButton = event.target.closest('.nav__item__button');
    if ($itemButton) {
      if ($itemButton.classList.contains('nav__item__button--subnav') || $itemButton.tagName === 'BUTTON') {
        if (event.target.classList.contains('nav__subnav-icon-container')) {
          event.preventDefault();
        }

        const $item = $itemButton.closest('.nav__item');
        this.toggleSubnav($item);
      }
    }

    if (event.target.classList.contains('nav__subnav__close')) {
      const $item = event.target.closest('.nav__item');
      this.toggleSubnav($item);
      allTrays.forEach((tray) => tray.classList.remove('desktop-subnav__tray--active'));
      event.preventDefault();
    }
  }

  onkeydown(event) {
    if (event.key === 'Escape') {
      this.closeSubnav();
      if (this.isMenuOpen) this.$menuCheckbox.click();
      return;
    }
    const isOpeningSubnav = OPEN_SUBNAV_KEYS.includes(event.key) &&
      event.target.matches('.nav__item__button--subnav');

    if (isOpeningSubnav) {
      event.preventDefault();
      const $item = event.target.closest('.nav__item');
      if ($item === this.$openSubnavItem && event.key !== 'ArrowDown') {
        this.closeSubnav();
      } else {
        this.openSubnav($item);
      }
    }
  }

  // close subnav if hovered over other item, desktop only
  // onmouseover(event) {
  // if (this.isMobile) return;
  // const $item = event.target.closest('.nav__item');
  // if ($item && $item !== this.$openSubnavItem) this.closeSubnav();
  // }

  onchange() {
    this.isMenuOpen = this.$menuCheckbox.checked;
    document.documentElement.classList.toggle('nav-menu-open', this.isMenuOpen);

    if (document.documentElement.classList.contains('nav-menu-open')) {
      this.$nav.style.position = 'fixed';
    } else {
      this.$nav.style.position = 'sticky';
    }
  }

  // programmatically trigger click to avoid browser setting scroll position to top
  onMenuLabelClick(event) {
    event.preventDefault();

    if (this.searchIsOpen) {
      const customEvent = new Event('menulabelclicked');
      window.dispatchEvent(customEvent);
    }

    this.$menuCheckbox.click();
  }

  openSubnav($item) {
    if (!$item) return;

    this.closeSubnav(this.$openSubnavItem); // close previous

    this.$openSubnavItem = $item;
    this.$openSubnavButton = $item.querySelector('.nav__item__button');
    this.$openSubnavItem.classList.add('is-subnav-open');
    this.$openSubnavButton.setAttribute('aria-expanded', 'true');
  }

  closeSubnav() {
    if (!this.$openSubnavItem) return;

    this.$openSubnavItem.classList.remove('is-subnav-open');
    this.$openSubnavButton.setAttribute('aria-expanded', 'false');
    this.$openSubnavItem = null;
    this.$openSubnavButton = null;
  }

  toggleSubnav($item) {
    if ($item === this.$openSubnavItem) {
      this.closeSubnav();
    } else {
      this.openSubnav($item);
    }
  }

  unmount() {
    this.$element.removeEventListener('keydown', this);
    this.mediaQuery.removeEventListener('change', this.onMediaChange);
    this.$menu.removeEventListener('click', this);
    this.$menuCheckbox.removeEventListener('change', this);
  }
}

registerModule('Nav', Nav);

// TODO make this fit in the tidy existing KitModule system
// this makes the desktop subnav...subnav assembly work
const mainNavButtons = document.querySelectorAll('.nav__item__button');
const subnavButtons = document.querySelectorAll('.desktop-subnav__button');
const allTrays = document.querySelectorAll('.desktop-subnav__tray');

mainNavButtons.forEach((mainNavButton) => {
  mainNavButton.addEventListener('click', (event) => {
    subnavButtons.forEach((subnavButton) => subnavButton.classList.remove('desktop-subnav__button--active'));
    allTrays.forEach((tray) => tray.classList.remove('desktop-subnav__tray--active'));


    if (event.target.getAttribute('aria-expanded') === 'false') {
      const subnavBtn = mainNavButton.parentElement.querySelector('.desktop-subnav__button');

      if (subnavBtn) {
        subnavBtn.classList.add('desktop-subnav__button--active');
      }

      const tray = mainNavButton.parentElement.querySelector('.desktop-subnav__tray');

      if (tray) {
        tray.classList.add('desktop-subnav__tray--active');
      }
    } else {
      allTrays.forEach((tray) => tray.classList.remove('desktop-subnav__tray--active'));
    }

    if (mainNavButton.parentElement.querySelector('.nav__subnav--desktop')) {
      event.preventDefault();
    }
  });
});

subnavButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    if (button.classList.contains('desktop-subnav__button--active')) return;
    const relevantTrays = button.parentElement.parentElement.querySelectorAll('.desktop-subnav__tray');
    const trayIndex = button.getAttribute('data-index');
    const relevantTray = button.parentElement.parentElement.querySelector(`.desktop-subnav__tray[data-index="${trayIndex}"]`);

    subnavButtons.forEach((siblingButton) => siblingButton.classList.remove('desktop-subnav__button--active'));
    relevantTrays.forEach((tray) => tray.classList.remove('desktop-subnav__tray--active'));

    button.classList.add('desktop-subnav__button--active');
    relevantTray.classList.add('desktop-subnav__tray--active');

    if (relevantTray) {
      event.preventDefault();
    }
  });
});
